import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconAddKeyframe: React.FC<CentralIconBaseProps> = (props) => {
  return (
    <CentralIconBase {...props} ariaLabel="add-keyframe, rhombus">
      <path
        d="M12 2.5L2.5 12L12 21.5L21.5 12L12 2.5Z"
        stroke="currentColor"
        strokeWidth="2"
      />
      <path
        d="M12 9V15M9 12H15"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="square"
      />
    </CentralIconBase>
  );
};

export default IconAddKeyframe;
